import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const AppDetailContentPoint = props => {
  const { title, points, partner, experimentation } = props;

  if (!title) return null;

  let mappedPoints = points || [];

  //TODO: remove this once the hood february promo is over for the third bullet  point
  if (
    partner === 'hood' &&
    !experimentation.hoodFebPromo &&
    mappedPoints.length > 2
  ) {
    mappedPoints = mappedPoints.slice(0, mappedPoints.length - 1);
  }

  return (
    <Fragment>
      <h4>{title}</h4>
      <ul>
        {mappedPoints.map((point, index) => (
          <li key={`${title.toLowerCase()}-${index + 1}`}>{point}</li>
        ))}
      </ul>
    </Fragment>
  );
};

AppDetailContentPoint.propTypes = {
  title: PropTypes.string,
  points: PropTypes.array,
  partner: PropTypes.string,
  experimentation: PropTypes.object
};

export default AppDetailContentPoint;
